// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import { Observer } from "mobx-vue";

import SlideUpDown from "vue-slide-up-down";

@Observer
@Component({
  mixins: [template],
  components: {
    SlideUpDown,
  },
})
export class ExpandButton extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
  public links!: object[];

  @Prop({ default: "" })
  public question!: string;

  @Prop({ default: false })
  public value!: boolean;

  @Prop({ default: "klicken und entdecken" })
  public teaser!: string;

  private isOpen: boolean = false;

  public toogleDropDown() {
    this.$emit("input", !this.value);
  }
}
